var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grant_Icon",
    "data-name": "Grant Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3516",
    "data-name": "Rectangle 3516",
    width: 32,
    height: 32,
    rx: 7,
    transform: "translate(0 32) rotate(-90)",
    fill: "#ddd",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12761",
    "data-name": "Path 12761",
    d: "M33.422,10.219h6.842l1.175-2.94c.443-1.107.077-1.764-.817-1.465L39,6.354,37.447,5.187a1.065,1.065,0,0,0-1.209,0L34.683,6.354l-1.62-.54c-.894-.3-1.261.358-.817,1.465Z",
    transform: "translate(-20.731 -0.999)",
    fill: "#5db76a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12762",
    "data-name": "Path 12762",
    d: "M19.062,45.847H25.33a6.978,6.978,0,0,0,6.977-6.979h0a8.472,8.472,0,0,0-2.115-5.105L25.31,27.974H19.082L14.2,33.763a8.471,8.471,0,0,0-2.115,5.105h0A6.978,6.978,0,0,0,19.062,45.847Z",
    transform: "translate(-6.085 -17.848)",
    fill: "#5db76a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrant);
export default __webpack_public_path__ + "static/media/grant.54a074554f6f54eaeed06f033fea32c5.svg";
export { ForwardRef as ReactComponent };